import { useEffect, useRef } from "react";
import { toast } from "react-toastify";

const useDevToolsLogout = (isLoggedIn) => {
  const logoutTriggered = useRef(false);
  const intervalRef = useRef(null);

  const handleLogout = () => {
    if (logoutTriggered.current) return;
    logoutTriggered.current = true;

    alert(
      "Security Alert! Developer tools detected. You are being logged out."
    );

    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace("/login");
    }, 1200);
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    if (process.env.NODE_ENV !== "production") return;

    // 1️⃣ Window size detection
    const detectSizeChange = () => {
      const widthDiff = window.outerWidth - window.innerWidth > 160;
      const heightDiff = window.outerHeight - window.innerHeight > 160;

      if (widthDiff || heightDiff) {
        handleLogout();
      }
    };

    // 2️⃣ Console inspection detection
    const element = new Image();
    Object.defineProperty(element, "id", {
      get() {
        handleLogout();
      },
    });

    const detectConsole = () => {
      console.log(element);
    };

    // 3️⃣ Debugger timing detection
    const detectDebugger = () => {
      const start = performance.now();
      debugger;
      const end = performance.now();

      if (end - start > 120) {
        handleLogout();
      }
    };

    // 4️⃣ Keyboard shortcut detection
    const detectShortcuts = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
        (e.ctrlKey && e.key === "U")
      ) {
        handleLogout();
      }
    };

    // 5️⃣ Resize detection
    const resizeListener = () => {
      detectSizeChange();
    };

    // attach listeners
    window.addEventListener("resize", resizeListener);
    window.addEventListener("keydown", detectShortcuts);

    // 6️⃣ Continuous detection loop
    intervalRef.current = setInterval(() => {
      detectSizeChange();
      detectConsole();
      detectDebugger();
    }, 1500);

    // cleanup
    return () => {
      window.removeEventListener("resize", resizeListener);
      window.removeEventListener("keydown", detectShortcuts);

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isLoggedIn]);
};

export default useDevToolsLogout;